"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
const react_1 = __importDefault(require("react"));
const StyledDiv = styled_components_1.default.div `
  height: ${(props) => {
    return props.height || "20px";
}};
  width: ${(props) => props.width || "100px"};
  border-radius: ${(props) => props.circle ? "50%" : props.rounded ? "4px" : "3px"};
  margin: 0 5px;
`;
exports.DummyField = (props) => {
    const { className, ...rest } = props;
    return react_1.default.createElement(StyledDiv, Object.assign({ className: `shimmer ${className || ""}` }, rest));
};
//# sourceMappingURL=DummyField.js.map